import React from 'react';
import ImageOptimizerTab from './coupang/ImageOptimizerTab';

function ImageOptimizer() {
  return (
    <div>
      <h1 className="text-2xl font-light text-gray-800 mb-6">이미지 최적화</h1>
      <div className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden" style={{ height: 'calc(100vh - 160px)' }}>
        <div className="flex h-full">
          <ImageOptimizerTab />
        </div>
      </div>
    </div>
  );
}

export default ImageOptimizer;
